// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1FVyz","subheader":"ReorderModal_subheader__2ID8T","listWrap":"ReorderModal_listWrap__3-tUE"};